import { API_URLS } from "../../constants/api/index.js"
async function CompositeOTPControl({refInfo ,password,userId,newpass,userOtp,param,id,entry,mail,phone}) {

   let responseData: { retCode: number, retMsg: string,refId: string} = {
      retCode: 99,
      retMsg: "",
      refId:""
     
   }
   const data = `{
         "id": "${id}",
         "entry": "${entry}",
         "refInfo": "${refInfo}",
         "password":"${password}",
         "userId": "${userId}",
         "newpass": "${newpass}",
         "userOtp": "${userOtp}",
         "param":"${param}",
         "mail": "${mail}",
         "phone":"${phone}"
        
   }`;


 //"https://azure-apigateway-openbanking-uat.apps.ocptest4.akbank.com/api/v1/ldapaccessbase/otp-control"
   await fetch(
  API_URLS.COMPOSITE3,
      { method: "POST", body: data }
     
  ).then(response => response.json())
      .then((textResponse) => {  
         debugger;
          responseData = {
            retCode: textResponse.retCode,           
             retMsg: textResponse.retMsg,
             refId:textResponse.refId
          };
      })
      .catch((error) => {
        
      })
  return responseData;
}

export { CompositeOTPControl }


